import { hexToRgb } from '../../styles/utils';
const elevationColor = '#111314';
const elevationRgb16 = hexToRgb(elevationColor, 0.16);
const elevationRgb12 = hexToRgb(elevationColor, 0.12);
const elevationRgb08 = hexToRgb(elevationColor, 0.08);
const elevations = {
    shadow100: `0 2px 4px -2px ${elevationRgb12}, 0 2px 8px ${elevationRgb12}`,
    shadow200: `0 2px 8px -2px ${elevationRgb16}, 0 8px 24px -2px ${elevationRgb08}`,
    shadow300: `0 8px 16px -6px ${elevationRgb08}, 0 12px 40px -4px ${elevationRgb12}`,
    shadow400: `0 8px 24px -6px ${elevationRgb12}, 0 12px 64px -4px ${elevationRgb12}`,
};
export default elevations;
